import { useState } from 'react';
import Link from 'next/link';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';

export default function MobileCategoryMenu({ menu }) {
  const [openCategoryMenu, setOpenCategoryMenu] = useState(false);
  function MenuItem({ menuItem }) {
    const [isOpen, setIsOpen] = useState(false);

    const handleItemClick = () => {
      setIsOpen(!isOpen);
    };

    return (
      <li key={menuItem.id}>
        <div className="flex justify-between items-center">
          <Link
            href={`${
              menuItem.type == 'product_category'
                ? '/cat/'
                : menuItem.type == 'brand'
                ? '/brand/'
                : menuItem.type == 'page'
                ? '/page/'
                : ''
            }${menuItem.url}`}
            className="flex py-3 justify-between"
            onClick={handleItemClick}
          >
            {menuItem.title}
          </Link>

          {menuItem.children.length > 0 && (
            <span onClick={handleItemClick}>
              <SmallArrowDown
                className={`${isOpen ? 'rotate-180' : ''}`}
                fill="#000"
              />
            </span>
          )}
        </div>

        {menuItem.children.length > 0 && (
          <ul className={`submenu pr-2 ${isOpen ? '' : 'hidden'}`}>
            {menuItem.children.map((childMenuItem) => (
              <MenuItem key={childMenuItem.id} menuItem={childMenuItem} />
            ))}
          </ul>
        )}
      </li>
    );
  }

  return (
    <div className="">
      <div className="py-2 flex justify-between my-2 items-center ">
        <div className="flex items-center">
          {menu.icon && (
            <span
              className="icon pl-2 "
              dangerouslySetInnerHTML={{ __html: menu.icon }}
            />
          )}
          {menu.title}
        </div>
        <span onClick={() => setOpenCategoryMenu(!openCategoryMenu)}>
          <SmallArrowDown
            className={`${openCategoryMenu ? 'rotate-180' : ''}`}
            fill="#000"
          />
        </span>
      </div>
      <ul className={`submenu ${openCategoryMenu ? '' : 'hidden'}`}>
        {menu &&
          menu.children.map((menuItem) => (
            <MenuItem key={menuItem.id} menuItem={menuItem} />
          ))}
      </ul>
    </div>
  );
}
